import _IconMenuFold from "@arco-design/web-react/icon/react-icon/IconMenuFold";
import _IconMenuUnfold from "@arco-design/web-react/icon/react-icon/IconMenuUnfold";
import "@arco-design/web-react/es/Spin/style";
import _Spin from "@arco-design/web-react/es/Spin";
import _IconNav from "@arco-design/web-react/icon/react-icon/IconNav";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import _IconFile from "@arco-design/web-react/icon/react-icon/IconFile";
import _IconCalendarClock from "@arco-design/web-react/icon/react-icon/IconCalendarClock";
import _IconSettings from "@arco-design/web-react/icon/react-icon/IconSettings";
import _IconApps from "@arco-design/web-react/icon/react-icon/IconApps";
import "@arco-design/web-react/es/Layout/style";
import _Layout from "@arco-design/web-react/es/Layout";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import cs from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import NProgress from 'nprogress';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import useRoute, { findMenuKeyByPathname, getRoutePath, isRouteMatched } from '@/routes';
import getUrlParams from './utils/getUrlParams';
import lazyload from './utils/lazyload';
import styles from './style/layout.module.less';
import './style/_common.less';
import { useDebounceEffect, useSize } from 'ahooks';
import { ModalProvider } from './context/ModalContext';
import { getUserPermissionCodes } from '@/services';
const MenuItem = _Menu.Item;
const SubMenu = _Menu.SubMenu;
const Sider = _Layout.Sider;
const Content = _Layout.Content;
function getIconFromKey(key) {
  switch (key) {
    case 'dashboard':
      return /*#__PURE__*/React.createElement(_IconApps, {
        className: styles.icon
      });
    case 'example':
      return /*#__PURE__*/React.createElement(_IconApps, {
        className: styles.icon
      });
    case 'system':
      return /*#__PURE__*/React.createElement(_IconSettings, {
        className: styles.icon
      });
    case 'auth':
      return null;
    case 'dict':
      return null;
    case 'department':
      return null;
    case 'org/index':
      return null;
    case 'org':
      return null;
    case 'users':
      return null;
    case 'roles':
      return null;
    case 'dicts':
      return null;
    case 'files':
      return null;
    case 'todo':
      return /*#__PURE__*/React.createElement(_IconCalendarClock, {
        className: styles.icon
      });
    // case 'modules/leave':
    //   return <IconSchedule className={styles.icon} />;
    // case 'modules/materials':
    //   return <IconCodepen className={styles.icon} />;
    case 'common':
      return /*#__PURE__*/React.createElement(_IconFile, {
        className: styles.icon
      });
    case 'ai':
      return /*#__PURE__*/React.createElement(_IconFile, {
        className: styles.icon
      });
    case 'flow/design':
      return /*#__PURE__*/React.createElement(_IconFile, {
        className: styles.icon
      });
    case 'personal':
      return /*#__PURE__*/React.createElement(_IconUser, {
        className: styles.icon
      });
    case 'drag':
      return /*#__PURE__*/React.createElement(_IconUser, {
        className: styles.icon
      });
    case 'modules':
      return /*#__PURE__*/React.createElement(_IconNav, {
        className: styles.icon
      });
    default:
      return null;
  }
}

// 模块级缓存：lazy 组件按路由 key 复用，保证组件引用稳定。
// 登录后 initBizData 拉回 menuKeys 会触发 useRoute 重算 → getFlattenRoutes 重跑；
// 若每次都 lazyload(...) 新建组件，Route 的 component 引用变化会让 React 把页面
// 组件卸载重建（表现为「路由页面初始化两次」）。
const lazyComponentCache = new Map();
function getLazyRouteComponent(cacheKey) {
  let component = lazyComponentCache.get(cacheKey);
  if (!component) {
    component = lazyload(() => import(`./pages/${cacheKey}`));
    lazyComponentCache.set(cacheKey, component);
  }
  return component;
}
function getFlattenRoutes(routes) {
  const res = [];
  function travel(_routes) {
    _routes.forEach(route => {
      const visibleChildren = (route.children || []).filter(child => !child.ignore);
      if (route.key && (!route.children || !visibleChildren.length)) {
        try {
          route.component = getLazyRouteComponent(route.componentPath || route.key);
          res.push(route);
        } catch (e) {
          console.error(e);
        }
      }
      if (route.children && route.children.length) {
        travel(route.children);
      }
    });
  }
  travel(routes);
  return res;
}
function getMatchedMenuState(pathname, routeList, parentRoutes = []) {
  for (const route of routeList) {
    const nextParentRoutes = route.ignore ? parentRoutes : [...parentRoutes, route];
    const visibleChildren = (route.children || []).filter(child => !child.ignore);
    if (route.children?.length) {
      const matched = getMatchedMenuState(pathname, route.children, nextParentRoutes);
      if (matched.selectedKeys.length || matched.openKeys.length) {
        return matched;
      }
    }
    const routePath = getRoutePath(route);
    if (isRouteMatched(pathname, routePath)) {
      if (route.ignore) {
        // Arco 的 SubMenu title 只有在子项 MenuItem 被选中时才高亮，
        // 因此命中 ignore 详情页时，高亮父级里最近的可点 MenuItem；
        // 若父级全是 SubMenu，则高亮最深层 SubMenu 的第一个可见子项。
        const menuItemAncestor = [...parentRoutes].reverse().find(r => {
          const visible = (r.children || []).filter(c => !c.ignore);
          return visible.length === 0;
        });
        let selectedKey = '';
        if (menuItemAncestor) {
          selectedKey = menuItemAncestor.key;
        } else {
          const deepest = parentRoutes[parentRoutes.length - 1];
          const firstVisible = (deepest?.children || []).find(c => !c.ignore);
          selectedKey = firstVisible?.key || '';
        }
        return {
          selectedKeys: selectedKey ? [selectedKey] : [],
          openKeys: parentRoutes.slice(0, -1).map(r => r.key)
        };
      }
      if (visibleChildren.length) {
        return {
          selectedKeys: [],
          openKeys: nextParentRoutes.map(r => r.key)
        };
      }
      return {
        selectedKeys: [route.key],
        openKeys: parentRoutes.map(r => r.key)
      };
    }
  }
  return {
    selectedKeys: [],
    openKeys: []
  };
}
function PageLayout() {
  const urlParams = getUrlParams();
  const history = useHistory();
  const pathname = history.location.pathname;
  const {
    settings,
    userLoading,
    userInfo,
    menuKeys
  } = useSelector(state => state);
  const isAdmin = userInfo?.account === 'admin';
  const [routes, defaultRoute] = useRoute(menuKeys, isAdmin);
  const defaultMenuState = getMatchedMenuState(pathname, routes);
  const defaultSelectedKeys = defaultMenuState.selectedKeys.length ? defaultMenuState.selectedKeys : [];
  const defaultOpenKeys = defaultMenuState.openKeys;
  const [collapsed, setCollapsed] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState(defaultSelectedKeys);
  const [openKeys, setOpenKeys] = useState(defaultOpenKeys);
  const [expandedMenuWidth, setExpandedMenuWidth] = useState(220);
  const size = useSize(document.body);
  const dispatch = useDispatch();

  // 路由变化时，获取当前页面操作权限编码（用路由自己的 key，不受 ignore 影响）
  useEffect(() => {
    const userId = userInfo?.userId;
    const menuKey = findMenuKeyByPathname(pathname);
    if (!userId || !menuKey) return;
    getUserPermissionCodes(userId, menuKey).then(codes => {
      dispatch({
        type: 'update-pagePermissionCodes',
        payload: {
          pagePermissionCodes: codes
        }
      });
    }).catch(() => {
      // 静默失败
    });
  }, [pathname, userInfo?.userId, dispatch]);
  const menuMap = useRef(new Map());
  const navbarHeight = 60;
  const menuWidth = collapsed ? 48 : expandedMenuWidth;
  const showNavbar = settings.navbar && urlParams.navbar !== false;
  const showMenu = settings.menu && urlParams.menu !== false;
  const showFooter = settings.footer && urlParams.footer !== false;
  const flattenRoutes = useMemo(() => getFlattenRoutes(routes) || [], [routes]);
  function renderRoutes() {
    return function travel(_routes, level, parentNode = []) {
      return _routes.map(route => {
        const {
          ignore
        } = route;
        const iconDom = getIconFromKey(route.key);
        const titleDom = /*#__PURE__*/React.createElement("span", {
          className: styles['menu-title']
        }, iconDom, /*#__PURE__*/React.createElement("span", null, route.name));
        const visibleChildren = (route.children || []).filter(child => {
          const {
            ignore
          } = child;
          return !ignore;
        });
        if (ignore) {
          return '';
        }
        if (visibleChildren.length) {
          menuMap.current.set(route.key, {
            subMenu: true
          });
          return /*#__PURE__*/React.createElement(SubMenu, {
            key: route.key,
            title: titleDom
          }, travel(visibleChildren, level + 1, [...parentNode, route.name]));
        }
        menuMap.current.set(route.key, {
          menuItem: true
        });
        return /*#__PURE__*/React.createElement(MenuItem, {
          key: route.key
        }, titleDom);
      });
    };
  }
  function onClickMenuItem(key) {
    const currentRoute = flattenRoutes.find(r => r.key === key);
    const component = currentRoute.component;
    const preload = component.preload();
    NProgress.start();
    preload.then(() => {
      history.push(getRoutePath(currentRoute));
      NProgress.done();
    });
  }
  function toggleCollapse() {
    setCollapsed(collapsed => !collapsed);
  }
  const paddingLeft = showMenu ? {
    paddingLeft: menuWidth
  } : {};
  const paddingTop = showNavbar ? {
    paddingTop: navbarHeight
  } : {};
  const paddingStyle = {
    ...paddingLeft,
    ...paddingTop
  };
  useEffect(() => {
    const matchedState = getMatchedMenuState(pathname, routes);
    setSelectedKeys(matchedState.selectedKeys);
    setOpenKeys(prevOpenKeys => Array.from(new Set([...prevOpenKeys, ...matchedState.openKeys])));
  }, [pathname, routes]);

  // 监听屏幕宽度，设置菜单栏宽度
  useDebounceEffect(() => {
    const viewportWidth = size?.width ?? (typeof window === 'undefined' ? 0 : window.innerWidth);
    const nextWidth = Math.round(viewportWidth * 0.12);
    setExpandedMenuWidth(Math.max(nextWidth, 220));
  }, [size?.width], {
    wait: 200
  });
  return /*#__PURE__*/React.createElement(ModalProvider, null, /*#__PURE__*/React.createElement(_Layout, {
    className: styles.layout
  }, /*#__PURE__*/React.createElement("div", {
    className: cs(styles['layout-navbar'], {
      [styles['layout-navbar-hidden']]: !showNavbar
    })
  }, /*#__PURE__*/React.createElement(Navbar, {
    show: showNavbar
  })), userLoading ? /*#__PURE__*/React.createElement(_Spin, {
    className: styles['spin']
  }) : /*#__PURE__*/React.createElement(_Layout, null, showMenu && /*#__PURE__*/React.createElement(Sider, {
    className: styles['layout-sider'],
    width: menuWidth,
    collapsed: collapsed,
    onCollapse: setCollapsed,
    trigger: null,
    collapsible: true,
    breakpoint: "xl",
    style: paddingTop
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['menu-wrapper']
  }, /*#__PURE__*/React.createElement(_Menu, {
    mode: "pop",
    collapse: collapsed,
    onClickMenuItem: onClickMenuItem,
    openKeys: openKeys,
    selectedKeys: [...selectedKeys],
    onClickSubMenu: (_, openKeys) => setOpenKeys(openKeys)
  }, renderRoutes()(routes, 1))), /*#__PURE__*/React.createElement("div", {
    className: styles['collapse-btn'],
    onClick: toggleCollapse
  }, collapsed ? /*#__PURE__*/React.createElement(_IconMenuUnfold, null) : /*#__PURE__*/React.createElement(_IconMenuFold, null))), /*#__PURE__*/React.createElement(_Layout, {
    className: styles['layout-content'],
    style: paddingStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['layout-content-wrapper']
  }, /*#__PURE__*/React.createElement(Content, null, /*#__PURE__*/React.createElement(Switch, null, flattenRoutes.map((route, index) => {
    return /*#__PURE__*/React.createElement(Route, {
      key: index,
      exact: route.exact !== false,
      path: getRoutePath(route),
      component: route.component
    });
  }), /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/"
  }, /*#__PURE__*/React.createElement(Redirect, {
    to: defaultRoute || '/example'
  })), /*#__PURE__*/React.createElement(Route, {
    path: "*",
    component: lazyload(() => import('./pages/exception/403'))
  })))), showFooter && /*#__PURE__*/React.createElement(Footer, null)))));
}
export default PageLayout;